import Login from './components/Auth/Login';
import Home from './components/Admin/home';
import ExternalUserList from './components/Admin/ExternalUsers/list';
import ExternalUserForm from './components/Admin/ExternalUsers/form';
import ExternalUserDetails from './components/Admin/ExternalUsers/details';
import ExternalUserManageProfile from './components/Admin/ExternalUsers/profileForm';
import WorkflowList from './components/Admin/Workflows/WorkflowList';
import WorkflowVersionsList from './components/Admin/Workflows/WorkflowVersions';
import MainWizard from './components/Admin/Workflows/Wizard/WorkflowWizard';
import FormCreate from './components/Admin/Forms/create';
import FormList from './components/Admin/Forms/list';
import FormDetails from './components/Admin/Forms/details';
import FormUpdate from './components/Admin/Forms/update';
import SubFormCreate from './components/Admin/SubForms/create';
import SubFormList from './components/Admin/SubForms/list';
import SubFormDetails from './components/Admin/SubForms/details';
import SubFormEdit from './components/Admin/SubForms/update';
import Approvals from './components/Admin/Approvals/Approvals';
import FormApprove from './components/Admin/Approvals/FormApprove';
import CategoriesWithReload from './components/Admin/Category/list';
import CategoryForm from './components/Admin/Category/form';
import CategoryOrganizations from './components/Admin/Category/organizations';
import CategoryOrganizationUsers from './components/Admin/Category/organizationUsers';

import Organizations from './components/Admin/Organization/list';
import OrganizationForm from './components/Admin/Organization/form';
import OrganizationDetails from './components/Admin/Organization/details';
import UserList from './components/Admin/Users/list';
import UserDetails from './components/Admin/Users/details';
import UserForm from './components/Admin/Users/form';
import RoleList from './components/Admin/Roles/list';
import RoleUsersList from './components/Admin/Roles/usersList';
import RoleForm from './components/Admin/Roles/form';
import Logs from './components/Admin/Logs/logs';
import LogDetails from './components/Admin/Logs/LogDetails';

import CustomerHome from './components/Guest/home';
// FormRenderer removed - was using jQuery formBuilder, now using FormCrafterFormRenderer
import MyRequests from './components/Guest/Requests/My_Requests/list';
import MyRequestDetails from './components/Guest/Requests/My_Requests/details';
import NewRequests from './components/Guest/Requests/New_Requests/list';
import NewRequestDetails from './components/Guest/Requests/New_Requests/details';
import CustomerRegister from './components/Auth/Register';
import ForgetPassword from './components/Auth/ForgetPassword';
import NewPassword from './components/Auth/NewPassword';
import SetupPassword from './components/Auth/SetupPassword';
import Organization from './components/Guest/Organization';
import HcpSignupResumeEntry from './components/HcpSignup/HcpSignupResumeEntry';
import HcpSignupGeneralInfoStep from './components/HcpSignup/HcpSignupGeneralInfoStep';
import HcpSignupLicensesStep from './components/HcpSignup/HcpSignupLicensesStep';
import HcpSignupEducationExperienceStep from './components/HcpSignup/HcpSignupEducationExperienceStep';
import HcpRequestDraftPage from './modules/hcpRequestDraft/HcpRequestDraftPage';
import CustomerProfileShell from './modules/customerProfile/CustomerProfileShell';
import LegacyHcpProfileRedirect from './modules/customerProfile/LegacyHcpProfileRedirect';
import HcpLicenseListTable from './components/Guest/HcpLicenseList/HcpLicenseListTable';
import HcpLicenseListDetail from './components/Guest/HcpLicenseList/HcpLicenseListDetail';
import AdminHcpLicenseListTable from './components/Admin/HcpLicenseList/HcpLicenseListTable';
import AdminHcpLicenseListDetail from './components/Admin/HcpLicenseList/HcpLicenseListDetail';

import RemdinerForm from './components/Sla_Reminders/form';
import { ErrorPage } from './components/error/ErrorPage';
import WorkflowViewer from './components/Admin/Workflows/Wizard/WorkflowViewer';
import NotificationConfigList from './components/Admin/GeneralNotifications/NotificationConfig';
import OTPVerification from './components/Auth/OTPVerification';
import OrgTree from './components/common/Org Tree/tree';
import AdminProfile from './components/Admin/Profile';
import ProviderList from './components/Admin/Payments/ProviderList';
import ProviderManage from './components/Admin/Payments/ProviderManage';
import PaymentProcessing from './components/Payment/PaymentProcessing';
import { RESOURCES } from './constants/resourceConstants';

// Log resources configuration
// Titles match URL patterns for consistency (e.g., admin-users -> Admin Users Logs)
const LOG_RESOURCES = [
  { resource: RESOURCES.ROLE_GROUPS, title: 'Role Groups Logs' },
  { resource: RESOURCES.ADMIN_USERS, title: 'Admin Users Logs' },
  { resource: RESOURCES.EXTERNAL_USERS, title: 'External Users Logs' },
  { resource: RESOURCES.SUBFORM, title: 'Subform Logs' },
  { resource: RESOURCES.FORM, title: 'Form Logs' },
  { resource: RESOURCES.WORKFLOWS, title: 'Workflows Logs' },
  {
    resource: RESOURCES.EXTERNAL_ORGANIZATIONS_CATEGORIES,
    title: 'External Users Categories Logs',
  },
  { resource: RESOURCES.ORG_STRUCTURE, title: 'Org Structure Logs' },
  { resource: RESOURCES.NOTIFICATIONS_SLA, title: 'Notifications SLA Logs' },
  { resource: RESOURCES.COMMENTS, title: 'Comments Logs' },
  {
    resource: RESOURCES.ADDITIONAL_DOCUMENTS,
    title: 'Additional Documents Logs',
  },
  { resource: 'other', title: 'Other Logs' },
];

// Generate log routes dynamically
const generateLogRoutes = (persona) => {
  return LOG_RESOURCES.flatMap(({ resource, title }) => [
    {
      path: `/${persona}/logs/${resource}`,
      title,
      element: Logs,
    },
    {
      path: `/${persona}/logs/${resource}/log/:id`,
      title: `${title} Details`,
      element: LogDetails,
    },
  ]);
};

// ADMIN ROUTES
export const adminRoutesConfig = [
  {
    path: '/admin/approvals/requests',
    title: 'Requests',
    element: Approvals,
  },
  {
    path: '/admin/categories',
    title: 'Categories',
    element: CategoriesWithReload,
  },
  {
    path: '/admin/categories/create',
    title: 'Create Category',
    element: CategoryForm,
  },
  {
    path: '/admin/categories/edit/:id',
    title: 'Edit Category',
    element: CategoryForm,
  },
  {
    path: '/admin/categories/:id/organizations',
    title: 'Organizations',
    element: CategoryOrganizations,
  },
  {
    path: '/admin/categories/:id',
    title: 'Organizations',
    element: CategoryOrganizations,
  },
  {
    path: '/admin/categories/:categoryId/organizations/:orgId/users',
    title: 'Organization Users',
    element: CategoryOrganizationUsers,
  },
  {
    path: '/admin/external-users',
    title: 'External Users',
    element: ExternalUserList,
    extraProps: { persona: 'admin' },
  },
  {
    path: '/admin/external-users/create',
    title: 'Create External User',
    element: ExternalUserForm,
    extraProps: { persona: 'admin' },
  },
  {
    path: '/admin/external-users/edit/:id',
    title: 'Edit External User',
    element: ExternalUserManageProfile,
    extraProps: { persona: 'admin' },
  },
  { path: '/admin/forms', title: 'Forms', element: FormList },
  { path: '/admin/forms/create', title: 'Create Form', element: FormCreate },
  {
    path: '/admin/forms/details/:id',
    title: 'Form Details',
    element: FormDetails,
  },
  {
    path: '/admin/forms/edit/:id',
    title: 'Edit Form',
    element: FormUpdate,
  },
  { path: '/admin/home', title: 'Homepage', element: Home },
  { path: '/admin', title: 'Homepage', element: Home },
  { path: '/admin/profile', title: 'Profile', element: AdminProfile },
  {
    path: '/admin/users/:id/profile',
    title: 'Profile',
    element: AdminProfile,
  },
  // Dynamic log routes
  ...generateLogRoutes('admin'),
  { path: '/admin/reminders', title: 'Reminders', element: RemdinerForm },
  {
    path: '/admin/notifications',
    title: 'Notification Configurations',
    element: NotificationConfigList,
  },
  { path: '/admin/review/:id', title: 'Review Form', element: FormApprove },
  { path: '/admin/roles', title: 'Roles', element: RoleList },
  {
    path: '/admin/roles/create',
    title: 'Create Role',
    element: RoleForm,
    extraProps: { caseProp: 'role' },
  },
  {
    path: '/admin/roles/edit/:id',
    title: 'Edit Role',
    element: RoleForm,
    extraProps: { caseProp: 'role' },
  },
  { path: '/admin/subforms', title: 'SubForms', element: SubFormList },
  {
    path: '/admin/subforms/create',
    title: 'Create SubForm',
    element: SubFormCreate,
  },
  {
    path: '/admin/subforms/details/:id',
    title: 'SubForm Details',
    element: SubFormDetails,
  },
  {
    path: '/admin/subforms/edit/:id',
    title: 'Edit SubForm',
    element: SubFormEdit,
  },
  {
    path: '/admin/user/privileges/:id',
    title: 'User Privileges',
    element: RoleForm,
    extraProps: { caseProp: 'user' },
  },
  { path: '/admin/users', title: 'Users', element: UserList },
  { path: '/admin/users/create', title: 'Create User', element: UserForm },
  { path: '/admin/users/edit/:id', title: 'Edit User', element: UserForm },
  { path: '/admin/workflows', title: 'Workflows', element: WorkflowList },
  {
    path: '/admin/workflows/create',
    title: 'Create Workflow',
    element: MainWizard,
  },
  {
    path: '/admin/workflows/draft/:draftId',
    title: 'Edit Workflow Draft',
    element: MainWizard,
  },
  {
    path: '/admin/workflows/:wfId/versions',
    title: 'Workflow Versions',
    element: WorkflowVersionsList,
  },
  {
    path: '/admin/workflows/:wfId/versions/create',
    title: 'Create Workflow Version',
    element: MainWizard,
  },
  {
    path: '/admin/workflows/:wfId/versions/:vId',
    title: 'Edit Workflow Version',
    element: MainWizard,
  },
  {
    path: '/admin/workflows/:wfId/versions/:vId/view',
    title: 'View Workflow Version',
    element: WorkflowViewer,
  },
  {
    path: '/admin/organization',
    title: 'Organizations',
    element: Organizations,
  },
  {
    path: '/admin/organization/create',
    title: 'Create Organization',
    element: OrganizationForm,
  },
  {
    path: '/admin/organization/details/:id',
    title: 'Organization Details',
    element: OrganizationDetails,
  },
  {
    path: '/admin/organization/structure/:id',
    title: 'Edit Organization',
    element: OrgTree,
  },
  {
    path: '/admin/payments',
    title: 'Payments',
    element: ProviderList,
  },
  {
    path: '/admin/payments/:code',
    title: 'Manage',
    element: ProviderManage,
  },
  {
    path: '/admin/hcp-licenses-list',
    title: 'HCP Licenses Registry',
    element: AdminHcpLicenseListTable,
  },
  {
    path: '/admin/hcp-licenses-list/details/:id',
    title: 'HCP License Details',
    element: AdminHcpLicenseListDetail,
  },
];

// CUSTOMER ROUTES
export const customerRoutesConfig = [
  { path: '/enduser/home', title: 'Homepage', element: CustomerHome },
  // Removed /enduser/subform route - was using jQuery formBuilder, now using FormCrafterFormRenderer
  {
    path: '/enduser/requests/my-requests',
    title: 'My Requests',
    element: MyRequests,
  },
  {
    path: '/enduser/progress/requests/:id',
    title: 'My Request Details',
    element: MyRequestDetails,
  },
  {
    path: '/enduser/requests/new-requests/view/:id',
    title: 'New Request Details',
    element: NewRequestDetails,
  },
  {
    path: '/enduser/requests/new-requests',
    title: 'New Requests',
    element: NewRequests,
  },
  {
    path: '/enduser/profile/*',
    title: 'Profile',
    element: CustomerProfileShell,
  },
  {
    path: '/enduser/hcp-profile',
    title: 'Profile',
    element: LegacyHcpProfileRedirect,
  },
  {
    path: '/enduser/hcp-licenses-list',
    title: 'HCP Licenses Registry',
    element: HcpLicenseListTable,
  },
  {
    path: '/enduser/hcp-licenses-list/details/:id',
    title: 'HCP License Details',
    element: HcpLicenseListDetail,
  },
  {
    path: '/enduser/requests/application-draft/:draftId',
    title: 'Application draft',
    element: HcpRequestDraftPage,
  },
  {
    path: '/enduser/organization/:id',
    title: 'Organization',
    element: Organization,
  },
];

// PUBLIC AUTH ROUTES — wrapped in PublicOnlyRoute (redirects if already signed in)
export const publicAuthRoutesConfig = [
  { path: '/', title: 'Login', element: Login },
  { path: '/login', title: 'Login', element: Login },
  {
    path: '/forgot-password',
    title: 'Forgot Password',
    element: ForgetPassword,
  },
  {
    path: '/new-password/:token',
    title: 'New Password',
    element: NewPassword,
  },
  {
    path: '/setup-password',
    title: 'Setup Password',
    element: SetupPassword,
  },
  { path: '/verify-otp', title: 'OTP Verification', element: OTPVerification },
  {
    path: '/payment/processing',
    title: 'Payment Processing',
    element: PaymentProcessing,
  },
  {
    path: '/enduser/register/legacy',
    title: 'Registration',
    element: CustomerRegister,
  },
  {
    path: '/enduser/register',
    title: 'HCP sign-up',
    element: HcpSignupResumeEntry,
  },
  {
    path: '/hcp-signup',
    title: 'HCP Sign-up Resume',
    element: HcpSignupResumeEntry,
  },
  {
    path: '/hcp-signup/step-1',
    title: 'HCP Sign-up',
    element: HcpSignupGeneralInfoStep,
  },
  {
    path: '/hcp-signup/step-2',
    title: 'HCP Sign-up Licenses',
    element: HcpSignupLicensesStep,
  },
  {
    path: '/hcp-signup/step-3',
    title: 'HCP Sign-up Education',
    element: HcpSignupEducationExperienceStep,
  },
];

// ERROR & CATCH-ALL ROUTES — always accessible, no auth check
export const errorRoutesConfig = [
  {
    path: '/error/404',
    title: '404 Not Found',
    element: ErrorPage,
    extraProps: { statusCode: 404 },
  },
  {
    path: '/error/403',
    title: '403 Forbidden',
    element: ErrorPage,
    extraProps: { statusCode: 403 },
  },
  {
    path: '/error/500',
    title: '500 Server Error',
    element: ErrorPage,
    extraProps: { statusCode: 500 },
  },
  {
    path: '*',
    title: '404 Not Found',
    element: ErrorPage,
    extraProps: { statusCode: 404 },
  },
];
